import Vue from "vue";

export default {
    async getBalancesViewModel() {
        return (await Vue.http.get("/api/payments/balances")).data;
    },
    async requestWithdrawalAsync(options) {
        return (await Vue.http.post(`/api/balance/${options.balanceId}/withdrawal/approval/request`, options)).data;
    },
    async getPaymentMethods(balanceId, operationType) {
        return (await Vue.http.get(`/api/payments/${balanceId}/${operationType}/methods`)).data;
    },
    async getConversionAsync(operationType, amount, from, to) {
        return (await Vue.http.get(`/api/payments/${operationType}/conversion`, { params: { amount, from, to: encodeURI(to) } })).data;
    },
    async createOperationAsync(options) {
        return (await Vue.http.post(`/api/payments/create?lang=${Vue.state.lang.currentLang}`, options)).data;
    },
    async getStatusAsync(id) {
        return (await Vue.http.get(`/api/payments/status/${id}`)).data;
    }
};


// WEBPACK FOOTER //
// ./_common/services/payment.service.js